import { AxiosRequestConfig } from 'axios'
import { api, ApiRes } from './client'
import {
    ObjectWithStringKeysAndStringArrayValue,
    ObjectWithStringKeysAndStringValue,
    OrdersPerIssuerItem,
} from '../../typings'

export interface GetOrdersPerIssuerProps {
    accountId: string
    order: boolean
    filters?: ObjectWithStringKeysAndStringValue
    limit?: number
}

export interface GetOrdersPerIssuerResponse {
    success: boolean
    issuers: OrdersPerIssuerItem[]
}

export interface GerOrdersProps {
    accountId: string
    filters?: ObjectWithStringKeysAndStringValue | ObjectWithStringKeysAndStringArrayValue
}

export function getOrdersPerIssuer(props: GetOrdersPerIssuerProps): ApiRes<GetOrdersPerIssuerResponse> {
    const { filters, accountId, order } = props
    const config: AxiosRequestConfig = {}
    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    config.params.order = order

    if (props.limit) {
        config.params.limit = props.limit
    }

    return api.get(`/portfolio/accounts/${accountId}`, config)
}

export function getOrders(props: GerOrdersProps) {
    const { filters, accountId } = props
    const config: AxiosRequestConfig = {}
    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    return api.get(`/portfolio-list/accounts/${accountId}`, config)
}
